// src/pages/AwardsListPage.js
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./Awards.css";
import apiClient from "../utils/apiClient"; // centralized API client
import SessionHandler from "../components/SessionHandler"; // global session expiry modal

const AwardsListPage = () => {
  const [awards, setAwards] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedAwardId, setSelectedAwardId] = useState(null);
  const navigate = useNavigate();

  // Fetch awards
  const fetchAwards = useCallback(async () => {
    try {
      const data = await apiClient("/awards/");
      if (!data) return; // session expired handled globally

      if (Array.isArray(data)) {
        setAwards(data);
      } else {
        setAwards(data.results || []);
      }
    } catch (err) {
      console.error("Error fetching awards:", err);
    }
  }, []);

  useEffect(() => {
    fetchAwards();
  }, [fetchAwards]);

  const handleAddReward = () => {
    navigate("/dashboard/ManagerAcess/addawards");
  };

  // Open confirmation modal
  const handleDeleteClick = (id) => {
    setSelectedAwardId(id);
    setShowDeleteModal(true);
  };

  // Confirm deletion
  const confirmDelete = async () => {
    if (!selectedAwardId) return;

    try {
      await apiClient(`/awards/${selectedAwardId}/`, {
        method: "DELETE",
      });
      // Refresh awards after deletion
      fetchAwards();
    } catch (err) {
      console.error("Error deleting award:", err);
    } finally {
      setShowDeleteModal(false);
      setSelectedAwardId(null);
    }
  };

  // Cancel deletion
  const cancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedAwardId(null);
  };

  return (
    <div className="awards-list-container">
      <div className="header-row">
        <h1 className="page-title">Awards & Recognitions</h1>
        <button className="add-btn" onClick={handleAddReward}>
          +
        </button>
      </div>

      <div className="table-wrapper">
        <table className="awards-table">
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Title</th>
              <th>Type</th>
              <th>Department</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {awards.length > 0 ? (
              awards.map((award) => (
                <tr key={award.id}>
                  <td data-label="Employee Name">{award.employeeName}</td>
                  <td data-label="Title">{award.title}</td>
                  <td data-label="Type">{award.type}</td>
                  <td data-label="Department">{award.department}</td>
                  <td data-label="Description">{award.description}</td>
                  <td data-label="Actions">
                    <button
                      className="delete-btn"
                      onClick={() => handleDeleteClick(award.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-data">
                  No awards found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal27-overlay">
          <div className="modal27-container">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this award?</p>
            <div className="modal27-actions">
              <button className="confirm-btn27" onClick={confirmDelete}>
                Yes, Delete
              </button>
              <button className="cancel-btn27" onClick={cancelDelete}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Global session expiry modal */}
      <SessionHandler />
    </div>
  );
};

export default AwardsListPage;
